export const data: OpacityMap = {};
export const keyframeGroups: KeyframeGroup = {};
